import produce from 'immer';
import { baseListFiltersActions } from '../actions';
import { ListFilterParams } from '../actions/base-list-filters.actions';

export interface ListFiltersState {
  snapshots: Record<string, ListFilterParams>;
}

export const INITIAL_LIST_FILTERS_STATE: ListFiltersState = {
  snapshots: {},
};

export function BaseListFiltersReducer(state: ListFiltersState = INITIAL_LIST_FILTERS_STATE, action: any): any {
  return produce(state, (draftState) => {
    switch (action.type) {
      case baseListFiltersActions.saveSnapshot.type:
        draftState.snapshots[action.routeKey] = action.params;
        return;

      case baseListFiltersActions.clearSnapshot.type:
        delete draftState.snapshots[action.routeKey];
        return;
    }
  });
}
